import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="localize-date"
export default class extends Controller {
  static targets = ["date"];

  // Available options: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
  static values = {
    year: { type: String, default: "numeric" },
    month: { type: String, default: "short" },
    day: { type: String, default: "numeric" },
    hour: { type: String, default: "numeric" },
    minute: { type: String, default: "numeric" },
    second: { type: String, default: "numeric" },
    showTime: { type: Boolean, default: false },
    showSecond: { type: Boolean, default: false },
    showYear: { type: Boolean, default: true },
    todayTime: { type: Boolean, default: false },
  };

  dateIsToday(date) {
    return new Date().toDateString() == date.toDateString();
  }

  connect() {
    // on reconnection it attempts to parse the time again (for example when pressing back button)
    if (this.element.dataset.alreadyRan) return;
    this.element.dataset.alreadyRan = true;

    // morphs would revert innerhtml to raw timestamp, and connect would not run
    // since it was a morph. Issue encountered during "mark all unread"
    this.element.dataset.turboPermanent = true;

    const dateInput = this.element.innerHTML.trim(); // "2025-03-28" or "2025-03-28 20:53:59 +0000"

    // Safari requires the string input to be in ISO 8601 format to create a date ("2025-03-28T20:53:59.000+00:00")
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#date_time_string_format

    let { date, time, tz } = dateInput.match(
      /^(?<date>\d{4}-\d{2}-\d{2})(\s(?<time>\d{2}:\d{2}:\d{2})\s(?<tz>[\+-]\d{4}))?$/,
    ).groups;
    const dateOnly = time == undefined;

    if (dateOnly) {
      date = new Date(date);
    } else {
      date = new Date(`${date}T${time}.000${tz.substring(0, 3)}:${tz.substring(3, 6)}`);
    }

    let options = {
      month: this.monthValue,
      day: this.dayValue,
    };

    if (this.showYearValue) {
      options.year = this.yearValue;
    }

    if ((this.todayTimeValue && this.dateIsToday(date)) || this.showTimeValue) {
      options.hour = this.hourValue;
      options.minute = this.minuteValue;
    }

    if (this.showSecondValue) {
      options.second = this.secondValue;
    }

    this.element.innerHTML = new Intl.DateTimeFormat(undefined, options).format(date);
  }
}
